const DEFAULT_ROUTES = {
    getBookingRoute: '/holiday-park/booking/get-booking-normalized',
    getMasterBookingExtrasRoute: '/holiday-park/booking/get-master-booking-extras-normalized',
}

function getBookingApiRoot() {
    return document.querySelector('[data-booking-api-root="true"]')
        ?? document.querySelector('#holiday-park-booking-page')
}

function getBookingApiRoute(key) {
    const root = getBookingApiRoot()

    return root?.dataset?.[key] ?? DEFAULT_ROUTES[key]
}

export { getBookingApiRoot, getBookingApiRoute }
